import { episodeListApi } from "../../api/HttpApis";
import { RxImage } from "react-icons/rx";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";
import Button from "../../component/button/Button";
import { useState } from "react";
import { CiImageOn } from "react-icons/ci";

const MediaImage = ({ src, alt }) => {
  const [hasError, setHasError] = useState(false);
  if (hasError || !src) return <CiImageOn size={40} />;
  return (
    <img
      className="imageBox"
      src={src}
      alt={alt || "Media"}
      width={40}
      height={30}
      onError={() => setHasError(true)}
    />
  );
};

export const EpisodesData = async (
  seriesId,
  seasonId,
  selectedDate,
  selectedCreator,
  selectedRating,
  selectedGenre,
  page,
  perpage
) => {
  const response = await episodeListApi(
    seriesId,
    seasonId,
    {},
    selectedDate,
    selectedCreator,
    selectedRating,
    selectedGenre,
    "",
    perpage,
    page
  );
  const dataArray = Array.isArray(response?.data?.data)
    ? response.data.data
    : [];
  return dataArray.map((item) => ({
    id: item.episode_id || item.id || item.original_id || item.video_id,
    metadata_id: item.metadata_id || item.meta_id || item.meta_data_id,
    name: trimStr(item.name,20),
    media: item.portrait,
    status: item.status,
    qc_status: item.qc_status,
    rating: item.rating,
    episodeNumber: item.episode_number,
    portrait_url: item.portrait,
    landscape_url: item.landscape,
    access: item.access,
    buttonText: "Edit",
    buttonText2: "Remove",
    totalCount: response?.data?.total,
  }));
};

export const Columns = (handleDelete, handleEdit, deletingId, editingId) => [
  {
    key: "name",
    label: "Name",
    render: (item) => (
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
          display: "block",
          minWidth: 0,
        }}
      >
        {trimStr(item.name, 15)}
      </div>
    ),
  },
  {
    key: "media",
    label: "Media",
    render: (item) => <MediaImage src={item.media} alt={item.name} />,  // ← only this changed
  },
  { key: "episodeNumber", label: "Episode" },
  { key: "status", label: "Status" },
  { key: "rating", label: "Rating" },
  { key: "access", label: "Access" },
  {
    key: "buttonText",
    render: (item) => (
      <Button
        onClick={() => handleEdit(item.id, item.metadata_id)}
        loading={editingId === (item.metadata_id || item.id)}
      >
        {item.buttonText}
      </Button>
    ),
  },
  {
    key: "buttonText2",
    render: (item) => (
      <Button
        onClick={() => handleDelete(item.id, item.metadata_id)}
        loading={deletingId === (item.metadata_id || item.id)}
        disabled={deletingId === (item.metadata_id || item.id)}
      >
        {deletingId === (item.metadata_id || item.id)
          ? "Deleting..."
          : item.buttonText2}
      </Button>
    ),
  },
];